<rt-dropdown>
  @if (searchEnabled) {
    <rt-form-field margin-small-x>
      <rt-input
        [autoFocus]="true"
        [formControl]="searchFormControl"
        placeholder="Search..."
        variant="rounded"
      >
        <rt-icon prefix name="search" />
      </rt-input>
    </rt-form-field>
  }
  <cdk-virtual-scroll-viewport
    #scrollViewport
    itemSize="49"
    class="items-container"
    (scrolledIndexChange)="onScrolledIndexChange()"
    [style.height]="getContainerHeight()"
  >
    <rt-dropdown-item
      *cdkVirtualFor="let el of data; trackBy: trackByMention; let index = index"
      (click)="select(el)"
      (mouseenter)="onElementHover(index)"
      [highlighted]="index === highlightedIndex"
      [hasHoverEffect]="false"
      class="cursor-pointer"
    >
      <div class="item">
        <rt-avatar
          [imageSrc]="el.avatar"
          [type]="el.hasAvatar ? 'image' : 'initials'"
          [initials]="el.initials"
          size="small-x"
          shape="oval"
          context="admin"
          margin-right-small-x
        />
        <rt-truncate>{{ el.name }}</rt-truncate>
      </div>
    </rt-dropdown-item>
  </cdk-virtual-scroll-viewport>
</rt-dropdown>
